import Home from '../Pages/Home';
import Trending from '../Pages/Trending';
import Movies from '../Pages/Movies';
import Series from '../Pages/Series';
import Search from '../Pages/Search';
import Terms from '../Pages/Terms';
import Privacy from '../Pages/Privacy';
import DMCA from '../Pages/DMCA';
import OurApp from '../Pages/OurApp';
import Guide from '../Pages/Guide';
import ContactForm from '../Pages/ContactForm';
import Apps from '../Pages/Apps';
import ZeppWF from '../Pages/ZeppWF';
import AppFirmware from '../Pages/AppFirmware';
import CardDetails from '../Pages/CardDetails';
import GuideForQR from '../Pages/GuideForQR';
import FAQs from '../Pages/FAQs';
import AppCardDetails from '../Pages/AppCardDetails';
import { Box } from "@mui/system";
import {Route, Routes } from "react-router-dom";
import { model } from '../config/config';
import { useEffect, useState } from "react";
const drawerWidth = 240;




function Main(){
	

    return (
        <Box
        component="main"
        sx={{ flexGrow: 1, width: {xs: '100%', md: `calc(100% - ${drawerWidth}px)` }, }}
      >
        <Routes>
            <Route path="/" exact element={<Home />}></Route>
			<Route path="/selectwatch/" exact element={<Home />}></Route>
            <Route path={`/${model}/latest`}  element={<Trending />}></Route>
            <Route path={`/${model}/random`} element={<Series />}></Route>
			<Route path={`/${model}/category`} element={<Movies />}></Route>
            <Route path={`/${model}/search`} element={<Search />}></Route>
			<Route path="/terms" element={<Terms />}></Route>
			<Route path="/privacy" element={<Privacy />}></Route>
			<Route path="/dmca" element={<DMCA />}></Route>
			<Route path="/ourapp" element={<OurApp />}></Route>
			<Route path="/guide" element={<Guide />}></Route>
			<Route path="/contactform" element={<ContactForm />}></Route>
			<Route path={`/${model}/apps`} element={<Apps />}></Route>
			<Route path={`/${model}/zeppwf`} element={<ZeppWF />}></Route>
			<Route path="/firmware" element={<AppFirmware />}></Route>
			<Route path={`/${model}/details/:fileid`}  exact component={CardDetails} element={<CardDetails />}></Route>
			<Route path={`/${model}/apps/:fileid`}  exact component={AppCardDetails} element={<AppCardDetails />}></Route>
			<Route path="/scanguide" element={<GuideForQR />}></Route>
			<Route path="/faqs" element={<FAQs />}></Route>
        </Routes>
      </Box>
    );
}
export default Main;